@if (!dataFetched) {
  <span>
    <pp-account-user-management-placeholder />
  </span>
}

<cdk-virtual-scroll-viewport
  itemSize="1"
  class="userManagementTable__wrapper"
  orientation="horizontal"
  #tableElement
>
  @if (user?.userId && dataFetched) {
    <section class="userManagementTable" aria-label="User management table">
      <pp-account-user-management-header
        [ppAccountId]="accountId"
        [ppCustomFields]="customFields"
      />
      <section class="userManagementTableSection">
        <pp-user-management-user-section
          *cdkVirtualFor="let user of filteredUsers; trackBy: trackByFunction"
          [ppUser]="user"
          [ppAccountId]="accountId"
          [ppCustomFields]="customFields"
        />
      </section>
      <pp-user-management-table-footer [ppNumberOfUsers]="filteredUsers.length" />
    </section>
  }
</cdk-virtual-scroll-viewport>

<pp-user-management-bulk-changes-bar [ppAccountId]="accountId" />
